import { call, takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { updateKiosk } from '../api';

import { reloadProviderData } from './helpers/reload-provider-data';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processUpdateKioskSaga(action: any) {
  const { data } = action;
  yield call(updateKiosk, data.id, { ...data });
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return yield reloadProviderData();
}

export default function* updateKioskSaga() {
  yield takeLatest(AT.UPDATE_KIOSK_SAGA, processUpdateKioskSaga);
}
